import { Component } from '@angular/core';

@Component({
  selector: 'wp-list',
  standalone: true,
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class ListComponent {}
